/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     .dx-field{margin:0;min-height:unset}[_nghost-%COMP%]     .dx-field-label{padding-top:2px;padding-bottom:2px}[_nghost-%COMP%]     .dx-field-value-static{padding-top:2px;padding-bottom:2px}"];
export { styles as styles };
